import { ExternalConnectionsProviders } from '@griply/types';

import { FirebaseHttpsCallableFactory } from '../types/firebase-functions';

export type GetExternalConnectionAuthUrlPayload = {
  provider: ExternalConnectionsProviders;
};

export type GetExternalConnectionAuthUrlOptions<TFunctions> = {
  functions: TFunctions;
  httpsCallable: FirebaseHttpsCallableFactory<TFunctions>;
  payload: GetExternalConnectionAuthUrlPayload;
};

export const getExternalConnectionAuthUrl = async <TFunctions>(
  options: GetExternalConnectionAuthUrlOptions<TFunctions>,
): Promise<string> => {
  const { functions, httpsCallable, payload } = options;
  const callable = httpsCallable<GetExternalConnectionAuthUrlPayload, string>(
    functions,
    'externalConnections-getAuthenticationURL',
  );

  const { data } = await callable(payload);

  return data;
};
